import React from "react";
import { Route, Routes } from "react-router-dom";

import ApiDocsService from "../core/services/ApiDocsService";
import CountryInterface from "../core/models/CountryInterface";

//state
import { useRecoilState } from "recoil";
import domainAtom from "../core/atoms/domainAtom";
import langAtom from "../core/atoms/langAtom";
import docsAtom from "../core/atoms/docsAtom";
import countryAtom from "../core/atoms/countryAtom";
import wordsAtom from "../core/atoms/wordsAtom";

//components
import Main from "../pages/Main";
import Meta from "./Meta/Meta";
import Footer from "./Footer/Footer";
import Lang from "./Lang/Lang";
import Docs from "../pages/Docs";
import Pages from "../pages/Pages";
import Domains from "../pages/Domains";
import Loader from "./Loader/Loader";

const App = () => {
  const host = window.location.host;
  // const host = "ecuador.cobs.ccprcentre.org"; // Pour les tests locaux, remplacer par le nom de domaine souhaité

  const subdomain = host
    .replace("http://", "")
    .replace("https://", "")
    .split(".");

  const [domain, setDomain] = useRecoilState(domainAtom);
  const [langList, setLangList] = React.useState<string[]>([]);
  const [lang, setLang] = useRecoilState<string>(langAtom);
  const [docs, setDocs] = useRecoilState(docsAtom);
  const [country, setCountry] = useRecoilState(countryAtom);
  const [words, setWords] = useRecoilState(wordsAtom);

  const [loadingWords, setLoadingWords] = React.useState(true); // Ajout de l'état de chargement pour `words`

  React.useEffect(() => {
    if (subdomain[0] !== "cobs") {
      setDomain(subdomain[0]);
      init(true);
    }
  }, []);

  React.useEffect(() => {
    if (subdomain[0] !== "cobs") {
      if (typeof lang !== "undefined") {
        localStorage.setItem("lang", String(lang));
      }
      getData();
      init();
      getWords();
    }
  }, [lang, domain]);

  const init = (firstInit = false) => {
    ApiDocsService.init(`?domain=${subdomain[0]}`).then((response) => {
      let selected;
      if (response.data.length > 1) {
        selected = response.data.find((item: CountryInterface) => {
          if (lang) return item.lang === lang;
          return +item.def === 1;
        });
      } else {
        selected = Array.isArray(response.data)
          ? response.data[0]
          : response.data;
      }
      setCountry(selected);
      if (!lang) {
        setLang(selected.lang);
      }

      if (firstInit) {
        setLangList(
          response.data.map((item: CountryInterface) => {
            return item.lang;
          })
        );
        setLang(selected.lang);
      }
    });
  };

  const getData = () => {
    ApiDocsService.getAll(`?domain=${subdomain[0]}&lang=${lang}`).then(
      (data) => {
        setDocs(data.data);
      }
    );
  };

  const getWords = async () => {
    if (lang) {
      setLoadingWords(true); // Activer le chargement avant l'appel
      try {
        const data = await ApiDocsService.getLang(lang);
        setWords(data.data);

        // Vérifie que toutes les propriétés nécessaires sont présentes
        if (
          data.data.site?.aware &&
          data.data.site?.tooriginal &&
          data.data.site?.body
        ) {
          setLoadingWords(false); // Les données sont prêtes
        } else {
          console.warn("Certaines propriétés sont manquantes dans `words`.");
        }
      } catch (error) {
        console.error("Erreur lors du chargement de `words`:", error);
      } finally {
        setLoadingWords(false); // Arrêter le chargement en cas d'erreur
      }
    }
  };

  if (subdomain[0] === "cobs") {
    return <Domains />;
  } else {
    if (!domain || domain === "" || loadingWords) {
      return <Loader active={true} />;
    }

    return (
      <>
        <Meta />

        <Lang langList={langList} default={lang} />

        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/doc/:url" element={<Docs />} />
          <Route path="/*" element={<Pages />} />
        </Routes>

        <Footer />
      </>
    );
  }
};

export default App;
